import React from 'react';
import {
  bool,
  oneOf,
  number,
  func,
  shape,
  string
} from 'prop-types';
import { Row, Col } from '@thd-olt-component-react/grid';
import { Quantity } from '@thd-olt-component-react/quantity';
import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import { Fulfillment } from '@thd-olt-component-react/fulfillment';
import '../buybox.scss';

const BuyboxUnavaiable = (props) => {
  const {
    itemId,
    quantity,
    onFulfillmentChange,
    onDeliveryOptionsZipCodeChange,
    hideQuantity,
    onQuantityChange,
    quantityLimitExceed
  } = props;
  return (
    <Col fallback="12">
      <div className="buybox-wrapper">
        <div className="buybox-top__wrapper">
          <div className="buybox__fulfillment-wrapper">
            <div className="buybox__fulfillment">
              <Fulfillment
                itemId={itemId}
                quantity={quantity}
                onChange={onFulfillmentChange}
                onDeliveryZipCodeChange={onDeliveryOptionsZipCodeChange}
              />
            </div>
          </div>
        </div>
        <div className="buybox__actions">
          {!hideQuantity && (
            <div className="buybox__quantity--wrapper">
              <Quantity
                value={quantity}
                onChange={onQuantityChange}
                className={quantityLimitExceed ? 'buybox__quantity--warning' : ''}
              />
            </div>
          )}
          <div className="buybox__atc--wrapper">
            <AddToCart disabled> Add to Cart </AddToCart>
          </div>

        </div>
        <div className="alert-inline alert-inline--danger">
          <span className="alert-inline__message">Unavailable combination. Please make another selection.</span>
        </div>
      </div>
    </Col>
  );
};

BuyboxUnavaiable.propTypes = {
  itemId: string.isRequired,
  quantity: number,
  onFulfillmentChange: func,
  onDeliveryOptionsZipCodeChange: func,
  hideQuantity: bool,
  onQuantityChange: func,
  quantityLimitExceed: bool
};

BuyboxUnavaiable.defaultProps = {
  quantity: 1,
  onFulfillmentChange: () => {},
  onDeliveryOptionsZipCodeChange: () => {},
  hideQuantity: false,
  onQuantityChange: () => {},
  quantityLimitExceed: false
};

export { BuyboxUnavaiable };
